export class EmployerContacts {
  whatsapp: boolean;
  telegram: boolean;
  viber: boolean;
  add_phone: string;
  add_whatsapp: boolean;
  add_telegram: boolean;
  add_viber: boolean;
}
